import { useCallback, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import messages from "../../../../assets/locale/messages";
import { ROUTE_PATHS } from "../../../../utils/RoutesPaths";
import { companyPermissionModules } from "../../../../utils/Constants";
import { useAdminModulePermission } from "../../../../utils/adminPortalHelpers";
import { showErrorMsg, showSuccessMsg } from "../../../../utils/Helpers";
import { createAdminCompanyRole } from "../../../../network/apis/adminCompanyRoles";
import {
  createEmptyPermissions,
  toPermissionsPayload,
} from "../../../Company-portal/TeamsPermissions/CreateRole/permissionModules";
import {
  adminCompanyTeamRoutes,
  COMPANY_DETAILS_TEAM_TAB,
  TEAM_SUB_TABS,
} from "../adminCompanyTeamRoutes";

const useAdminCreateRole = () => {
  const history = useHistory();
  const { companyId } = useParams();
  const lang = useSelector((state) => state.locale.lang);
  const teamCopy = messages[lang].teamManagement;
  const copy = teamCopy.createRole;
  const companiesList = messages[lang].companiesList;
  const { shared } = messages[lang];
  const { canAdd } = useAdminModulePermission(
    companyPermissionModules.rolesManagement,
  );

  const [name, setName] = useState("");
  const [nameTouched, setNameTouched] = useState(false);
  const [permissions, setPermissions] = useState(createEmptyPermissions);
  const [creating, setCreating] = useState(false);

  const goBackToList = useCallback(() => {
    if (!companyId) {
      history.push(ROUTE_PATHS.companiesList);
      return;
    }
    history.push(
      adminCompanyTeamRoutes.companyDetailsTabLocation(
        companyId,
        COMPANY_DETAILS_TEAM_TAB,
        TEAM_SUB_TABS.roles,
      ),
    );
  }, [history, companyId]);

  const trimmedName = name.trim();
  const showNameError = nameTouched && !trimmedName;

  const breadcrumbList = [
    { path: ROUTE_PATHS.companiesList, label: companiesList.listBreadcrumb },
    {
      path: companyId
        ? adminCompanyTeamRoutes.companyDetailsTeamTab(companyId, TEAM_SUB_TABS.roles)
        : "",
      label: companiesList.teamPermissionsTab,
    },
    { path: "", label: copy.title },
  ];

  const handleSubmit = async () => {
    setNameTouched(true);
    if (!trimmedName || creating || !companyId) return;

    setCreating(true);
    try {
      await createAdminCompanyRole({
        company_id: companyId,
        name: trimmedName,
        permissions: toPermissionsPayload(permissions),
      });
      showSuccessMsg("addedSuccessfully");
      goBackToList();
    } catch (error) {
      showErrorMsg(error?.response?.data?.message || shared.generalErrMsg);
    } finally {
      setCreating(false);
    }
  };

  return {
    copy,
    breadcrumbList,
    name,
    setName,
    setNameTouched,
    permissions,
    setPermissions,
    showNameError,
    creating,
    canAdd,
    goBackToList,
    handleSubmit,
    trimmedName,
  };
};

export default useAdminCreateRole;
